import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from '@ebay/nice-modal-react';

// Import components
import { ChannelsModal } from 'components/elements/molecules/ChannelsModal/ChannelsModal';

// Import context
import { useMainPacketContext } from 'components/context/main_packet/MainPacketProvider';

export const useChannelsModal = () => {
	const { t } = useTranslation('configurator');
	const modal = useModal(ChannelsModal);

	const { packet } = useMainPacketContext();

	const openModal = useCallback(() => {
		modal.show({ channels: packet.channels, title: t('modal_packet_channels_title', { title: packet.title }) });
	}, []);

	return openModal;
};
